export const START_CONNECTION = 'START_CONNECTION';
export const CONNECTION_CHANGE = 'CONNECTION_CHANGE';
export const ONLINE_CHANGE = 'ONLINE_CHANGE';

export const startConnection = botConnection => ({
  type: START_CONNECTION,
  botConnection
});

export const connectionChange = ({ connectionStatus, botConnection }) => ({
  type: CONNECTION_CHANGE,
  connectionStatus,
  botConnection
});

export const onlineChange = ({ online }) => ({
  type: ONLINE_CHANGE,
  online
});



// WEBPACK FOOTER //
// ./src/reducers/connection/actions.js